import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-arquivos',
  templateUrl: './arquivos.component.html',
  styleUrls: ['./arquivos.component.css']
})
export class ArquivoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
